<template>
  <v-item-group multiple>
    <v-item v-for="k in Object.keys(choices)" :key="k">
      <v-chip
        slot-scope="{ active, toggle }"
        :outline="value.indexOf(k) === -1"
        @click="add(k)"
        @input="remove(k)"
        :close="value.indexOf(k) !== -1 && value.length > 1"
      >
        {{ choices[k] }}
      </v-chip>
    </v-item>
  </v-item-group>
</template>

<script>
export default {
  name: "FiltersGroup",
  props: ["choices", "value"],
  methods: {
    remove(k) {
      let idx = this.value.indexOf(k);
      if (idx !== -1) {
        this.$emit("input", this.value.filter((v, _i) => _i !== idx));
      }
    },
    add(k) {
      let idx = this.value.indexOf(k);
      if (idx === -1) {
        this.$emit("input", [...this.value, k]);
      }
    }
  }
};
</script>

<style>
.v-chip:after {
  display: none;
}
</style>
